export const CONNECTION_HUB_API_BASE = "/connections";

export const CONNECTION_HUB_ENDPOINTS = {
  channels: `${CONNECTION_HUB_API_BASE}/channels`,
  accounts: (ipId: string) =>
    `${CONNECTION_HUB_API_BASE}/channels/${encodeURIComponent(ipId)}/accounts`,
  emailSuggestions: `${CONNECTION_HUB_API_BASE}/email-suggestions`,
  drafts: `${CONNECTION_HUB_API_BASE}/drafts`,
  draft: (ipId: string) =>
    `${CONNECTION_HUB_API_BASE}/drafts/${encodeURIComponent(ipId)}`,
  setup: `${CONNECTION_HUB_API_BASE}/setup`,
  resolveSetup: `${CONNECTION_HUB_API_BASE}/setup/resolve`,
  forwardingConfirmation: (inboxId: string) =>
    `${CONNECTION_HUB_API_BASE}/inboxes/${encodeURIComponent(inboxId)}/forwarding/confirm`,
  filterConfirmation: (inboxId: string) =>
    `${CONNECTION_HUB_API_BASE}/inboxes/${encodeURIComponent(inboxId)}/filter/confirm`,
  inboxRecheck: (inboxId: string) =>
    `${CONNECTION_HUB_API_BASE}/inboxes/${encodeURIComponent(inboxId)}/recheck`,
  inboxVerification: (inboxId: string) =>
    `${CONNECTION_HUB_API_BASE}/inboxes/${encodeURIComponent(inboxId)}/verify`,
  delegation: (inboxId: string) =>
    `${CONNECTION_HUB_API_BASE}/inboxes/${encodeURIComponent(inboxId)}/delegation`,
  delegationResend: (inboxId: string) =>
    `${CONNECTION_HUB_API_BASE}/inboxes/${encodeURIComponent(inboxId)}/delegation/resend`,
  connectionVerification: (connectionId: string) =>
    `${CONNECTION_HUB_API_BASE}/${encodeURIComponent(connectionId)}/verify`,
  connectionSubBrands: (connectionId: string) =>
    `${CONNECTION_HUB_API_BASE}/${encodeURIComponent(connectionId)}/sub-brands`,
  connectionCredentials: (connectionId: string) =>
    `${CONNECTION_HUB_API_BASE}/${encodeURIComponent(connectionId)}/credentials`,
  connection: (connectionId: string) =>
    `${CONNECTION_HUB_API_BASE}/${encodeURIComponent(connectionId)}`,
  delegate: (token: string) =>
    `${CONNECTION_HUB_API_BASE}/delegate/${encodeURIComponent(token)}`,
  delegateForwardingConfirmation: (token: string) =>
    `${CONNECTION_HUB_API_BASE}/delegate/${encodeURIComponent(token)}/forwarding/confirm`,
  delegateFilterConfirmation: (token: string) =>
    `${CONNECTION_HUB_API_BASE}/delegate/${encodeURIComponent(token)}/filter/confirm`,
  delegateVerification: (token: string) =>
    `${CONNECTION_HUB_API_BASE}/delegate/${encodeURIComponent(token)}/verify`,
  delegateCredentials: (token: string, connectionId: string) =>
    `${CONNECTION_HUB_API_BASE}/delegate/${encodeURIComponent(token)}/connections/${encodeURIComponent(connectionId)}/credentials`,
} as const;

export const CONNECTION_STATUS_UPDATED = "CONNECTION_STATUS_UPDATED";

export const REQUEST_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
} as const;

export type RequestStatus =
  (typeof REQUEST_STATUS)[keyof typeof REQUEST_STATUS];

export const CONNECTION_HUB_DEFAULTS = {
  source: null,
  agencyClientId: null,
  mode: null,
  selectedIpIds: [] as string[],
  activeIpId: null,
} as const;
